import submit from "submit-form";
import { useTranslation } from "react-i18next";

export default function DownloadCoachMobileAppButtonHeader({
  activeUser,
  //   isActivePull,
}) {
  const { t } = useTranslation("coaching-portal");
  const { webAppTheme = "dark", email } = activeUser;
  /**
   * Function to send the email to download the mobile app to the logged coach
   * @param {*} e
   */
  const handleSendEmail = (e) => {
    e.stopPropagation();
    e.preventDefault();
    submit("/actions/user/send-custom-email", {
      method: "POST",
      body: {
        email,
        type: "download-coach-mobile-app",
      },
    });
  };

  // Uncomment this code to enable the Year In Review (seasonal, turned on
  // once a year). Also needs:
  //   import { useState } from "react";
  //   import YearInReview from "./modals/year-in-review";
  //   const [modalOpened, setModalOpened] = useState(false);
  //   return (
  //     <>
  //       <button
  //         style={{
  //           background:
  //             "linear-gradient(135deg, rgba(255,100,50,1) 15%, rgba(145,38,228,1) 100%)",
  //           height: "2.5rem",
  //         }}
  //         type="button"
  //         onClick={() => setModalOpened(true)}
  //       >
  //         <img src="/img/new-icons/vuesax-linear-calendar.svg" alt="calendar" />
  //         <span
  //           style={{
  //             font: "normal normal bold 14px/17px Inter",
  //             color: "#ffffff",
  //             marginLeft: "0.5rem",
  //           }}
  //         >
  //           Year In Review
  //         </span>
  //       </button>
  //       {modalOpened && (
  //         <YearInReview
  //           closeModal={() => setModalOpened(false)}
  //           onCoachAppClick={handleSendEmail}
  //         />
  //       )}
  //     </>
  //   );

  return (
    <button
      id="download-coach-mobile-app"
      data-button-type="secondary"
      onClick={handleSendEmail}
    >
      <div className="flex gap-1 items-center min-h-4">
        {/* <span className="clipped font-semibold h-full">[NEW]</span> */}
        <span className="h-full">{t("downloadCoachMobileApp.getCoachMobileApp")}</span>
      </div>
      <div className="w-8 flex justify-end items-center">
        <img
          src="/img/new-icons/mobile-linear.svg"
          className={webAppTheme === "dark" ? "filter-white" : "filter-black"}
        />
      </div>
    </button>
  );
}
